import React from 'react';
import styled from 'styled-components';
import { PineconeThemeProvider } from 'ui-toolkit/theming/PineconeThemeProvider';
import type { FCWithChildren } from '../../types/FCWithChildren';

const SideDrawerWrapper = styled.div`
  grid-area: side-drawer;
  position: relative;
  box-shadow: 0 0 3px rgb(0 0 0 / 25%);
  min-height: 100vh;
`;

export const SideDrawer: FCWithChildren = ({ children }) => {
  return <PineconeThemeProvider>{children && <SideDrawerWrapper>{children}</SideDrawerWrapper>}</PineconeThemeProvider>;
};
